import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoTab from 'eco-design/elements/eco-tab';
import { useState } from 'react';
import styles from './index.module.scss';

import CarPort from '@/components/UI/svg/trail-series/CarPort';
import USBA from '@/components/UI/svg/trail-series/USBA';
import USBC from '@/components/UI/svg/trail-series/USBC';
import { useGlobal } from '@/utils/useGlobal';
import getLocal from '@/app/utils/i18n';

export default function TabSwriper1() {
    const { useLang } = useGlobal();
    const { t } = useLang('TrailSeries.tabSwriper1');
    const { locale } = getLocal();
    const [activeTab, setActiveTab] = useState(locale === 'ph' ? t('tab_title1') : t('tab_title2'));
    const [activeIndex, setActiveIndex] = useState(locale === 'ph' ? 0 : 1);

    const Tabs = [
        {
            title: t('tab_title1'),
            items: [
                { name: t('tab_item1_name1'), times: t('tab_item1_time1'), icon: <USBC /> },
                { name: t('tab_item1_name2'), times: t('tab_item1_time2'), icon: <USBC /> },
                { name: t('tab_item1_name3'), times: t('tab_item1_time3'), icon: <USBA /> },
            ],
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753670356461/tab1_pc_2.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753670356210/tab1_pad_2.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753670355754/tab1_h5_2.png',
        },
        {
            title: t('tab_title2'),
            items: [
                { name: t('tab_item2_name1'), times: t('tab_item2_time1'), icon: <USBC /> },
                { name: t('tab_item2_name2'), times: t('tab_item2_time2'), icon: <USBA /> },
                { name: t('tab_item2_name3'), times: t('tab_item2_time3'), icon: <CarPort /> },
            ],
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753670354885/tab1_pc_1.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753670356682/tab1_pad_1.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753670354677/tab1_h5_1.png',
        },
        {
            title: t('tab_title3'),
            items: [
                { name: t('tab_item3_name1'), times: t('tab_item3_time1'), icon: <USBC /> },
                { name: t('tab_item3_name2'), times: t('tab_item3_time2'), icon: <USBA /> },
                { name: t('tab_item3_name3'), times: t('tab_item3_time3'), icon: <CarPort /> },
            ],
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753670355475/tab1_pc_3.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753670355253/tab1_pad_3.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753670356001/tab1_h5_3.png',
        },
    ];

    const TabItems = Tabs.map((item) => ({ tabValue: item.title, tabLabel: item.title }));

    const onTabChange = (item: any, index: number) => {
        setActiveTab(item.tabValue);
        setActiveIndex(index);
    };

    return (
        <div className={`page-tabSwriper1 ${styles.TabSwriper1} GtmModuleData-section`} data-section-id="TabSwriper1" id="TabSwriper1">
            <EcoSpace hPc="180px" />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.TabSwriper1}`}>
                <div className="tab-container">
                    <div className="tab-wrapper">
                        <div className="content-image">
                            <EcoImg pc={Tabs[activeIndex].pc} pad={Tabs[activeIndex].pad} h5={Tabs[activeIndex].h5} />
                        </div>
                        <div className="tab-content">
                            <div className="content-items">
                                {Tabs[activeIndex].items.map((item, index) => (
                                    <div key={index} className="item">
                                        <div className="item-icon">{item.icon}</div>
                                        <div className="item-info">
                                            <div className="item-times">{item.times}</div>
                                            <div className="item-name">{item.name}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="tab-headers">
                        <EcoTab activeKey={activeTab} activeIndex={activeIndex} gtmTitle={t('title')} items={TabItems} onChange={onTabChange} />
                    </div>
                    <div className="tip">{t('tip')}</div>
                </div>
            </div>
        </div>
    );
}
